import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    //currentuser
  },

  actions: {
    init ({ dispatch }) {
      return Promise.all([
        //dispatch('currentuser/loadCurrentUser'),
        dispatch('app/loadLocale')
      ])
        .catch(error => {
          console.log("Error in store init: ", error)
        })
    }
  }
})

export default store
